import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from '../../../Form';
import { BoxTitle, Box } from '../../../PageTemplate';
import { Validation } from '../../../../helper';
import { handleChange, updateTimeout} from './utils';

const {REACT_APP_MAX_IMAGES_EVENT, REACT_APP_MAX_IMAGES_DEMO_EVENT} = process.env;

class Limit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            eventData: {},
            fields: {},
            error: {
                maxImages: {
                    event: false,
                    user: false,
                    copy: false
                }
            },
            imagesLimit: Number(REACT_APP_MAX_IMAGES_EVENT),
            eventFinised: false
        }

        this.handleChange = handleChange.bind(this);    
        this.updateTimeout = updateTimeout.bind(this);   
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised} = props;
        const events = props.events.list;
        const eventID = props.events.currentEventID;
        const newState = {};
        const newStateData = {};
        const newStateFields = {};

        if(!events || !events[eventID]) return null;
        
        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;
        
        const {maxImages, demo} = events[eventID];
        const demoImagesLimit = Number(REACT_APP_MAX_IMAGES_DEMO_EVENT);
        if(demo && state.imagesLimit !== demoImagesLimit) newState.imagesLimit = demoImagesLimit;

        for(let p in maxImages) {
            if(!newStateData.maxImages) newStateData.maxImages = {};

            newStateData.maxImages[p] = maxImages[p];

            if(!state.fields.maxImages || !state.fields.maxImages[p]) {
                if(!newStateFields.maxImages) newStateFields.maxImages = {};
                newStateFields.maxImages[p] = maxImages[p];
            }
        }

        if(Object.keys(newStateData).length > 0) newState.eventData = newStateData;
        if(Object.keys(newStateFields).length > 0) newState.fields = {...state.fields, ...newStateFields};
        if(Object.keys(newState).length > 0) return newState;

        return null;
    }

    validation() {
        const {event, user, copy} = this.state.fields.maxImages;

        const invalidRange = (num) => !!!num || Number(num) < 1 || Number(num) > this.state.imagesLimit;
        
        var err = {
            maxImages: {
                event: !Validation.onlyNumbers(event) || invalidRange(event),
                user: !Validation.onlyNumbers(user) || invalidRange(user),
                copy: !Validation.onlyNumbers(copy) || invalidRange(copy)
            }
        }

        this.setState({error: {...this.state.error, ...err}});

        const hasError = JSON.stringify(err);
        return hasError.indexOf(true) === -1;
    }

    render() {
        const {maxImages} = this.state.fields;
        const event = (maxImages && maxImages.event) || "";
        const user = (maxImages && maxImages.user) || "";
        const copy = (maxImages && maxImages.copy) || "";

        return (
            <Box col="1">
                <BoxTitle icon="faImages">
                    הגבלות
                </BoxTitle>
                <Input
                    name="maxImages.event"
                    value={event || ""}
                    placeholder="מקסימום מגנטים (כולל שכפולים) באירוע:"
                    error={this.state.error.maxImages.event}
                    errorText={`בין- 1 ל- ${this.state.imagesLimit}`}
                    onChange={this.handleChange}
                    label={true}
                    type="number"
                    disabled={this.state.eventFinised}
                />
                <Input
                    name="maxImages.user"
                    value={user || ""}
                    placeholder="מקסימום מגנטים לאורח:"
                    error={this.state.error.maxImages.user}
                    errorText={`בין- 1 ל- ${this.state.imagesLimit}`}
                    onChange={this.handleChange}
                    label={true}
                    type="number"
                    disabled={this.state.eventFinised}
                />
                <Input
                    name="maxImages.copy"
                    value={copy || ""}
                    placeholder="מקסימום שכפולים למגנט:"
                    error={this.state.error.maxImages.copy}
                    errorText={`בין- 1 ל- ${this.state.imagesLimit}`}
                    onChange={this.handleChange}
                    label={true}
                    type="number"
                    disabled={this.state.eventFinised}
                />
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const LimitWithRedux = connect(mapStateToProps)(Limit);

export {LimitWithRedux as Limit};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/event/Limit.jsx